<template>
    <v-dialog v-model="isVisible" :max-width="maxWidth" @click:outside="closeDialog">
        <v-card :style="dialogStyle">
            <!-- Top-left Copy Icon -->
            <v-card-actions>
                <v-btn
                    color="secondary darken-3"
                    icon
                    x-small
                    @click="copyContent(content)"
                >
                    <v-icon v-text="icons.mdiContentCopy"></v-icon>
                </v-btn>

                <!-- Close button on the top-right -->
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    small
                    @click="closeDialog"
                >
                    <v-icon v-text="icons.mdiClose"></v-icon>
                </v-btn>
            </v-card-actions>

            <!-- Text content in the dialog -->
            <v-card-text>
                <pre class="wrapped-text">{{ content }}</pre>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapMutations } from "vuex";
import { isObject } from "lodash";
import {
    mdiContentCopy,
    mdiClose
} from "@mdi/js";

export default {
    props: {
        isVisible: {
            type: Boolean,
            required: true,
        },
        content: {
            type: [String, Object],
            required: true,
        },
        maxWidth: {
            type: [Number, String],
            default: 400
        }
    },
    data() {
      return {
          icons: {
              mdiContentCopy,
              mdiClose
          },
      }
    },
    computed: {
        lang() {
            return this.$route.params.lang;
        },
        dialogStyle() {
            return {
                width: 'auto', // Allow width to shrink based on content
                maxWidth: this.maxWidth + 'px', // Set max-width from prop
                minWidth: '200px', // Optional: Set a minimum width for smaller content
            };
        }
    },
    methods: {
        ...mapMutations([
            "setNotification"
        ]),
        closeDialog() {
            this.$emit('update:isVisible', false);
        },
        copyContent(val) {
            let copyDone = {
                en: "Copied to clipboard!",
                el: "Αντιγράφηκε!",
                it: "Copiato"
            };

            if(isObject(val)) {
                val = JSON.stringify(val);
            }

            navigator.clipboard.writeText(val);
            this.setNotification({
                show: true,
                type: "info",
                text: copyDone[this.lang]
            });
            setTimeout(() => this.setNotification({
                show: false,
                type: "info",
                text: ""
            }), 2100);
        }
    }
};
</script>


<style scoped>
.wrapped-text {
    white-space: pre-wrap; /* Preserve whitespace but allow wrapping */
    word-wrap: break-word; /* Break long words if needed */
    overflow-wrap: break-word; /* Ensure long words break correctly */
    max-width: 100%;
}

::v-deep .v-dialog {
    width: auto !important; /* Set width to auto */
}
</style>